export const CART_JWT_KEY = "rulle";

export const CONTACT_EMAIL_ADDRESS = "butik@nylandersmattor.se";
export const CONTACT_PHONE_NUMBER = "033-12 30 50";
export const PRODUCT_IMAGE_URL = "https://img.nylandersmattor.se/";
export const BLOG_IMAGE_URL = "https://old.nylandersmattor.se/assets/img/blogg/";
export const BLOG_IMAGE_PATH = "/images/blogg/";
export const PAGE_NAME = "Nylanders Mattor";
export const PAGE_TITLE_SUFFIX = ` - ${PAGE_NAME}`;

export const TYPE_NORMAL = "normal";
export const TYPE_METER = "meter";
export const TYPE_KVM = "kvadratmeter";

export const SHAPE_ROUND_STRING = "rund";
export const SHAPE_RECTANGLE_STRING = "fyrkantig";

export const SAMPLE_SIZE_ID = 19237;
export const SAMPLE_PRICE = 20;

export const TAX_RATE_PERCENT = 25; // 25% on top of price.

export const SHIPPING_LABEL_STORAGE_BUCKET = "nylandersmattor-shipping-labels";

export const DISCOUNT_TYPES = {
    FREE_SHIPPING: "FREE_SHIPPING",
    PERCENT: "PERCENT",
    AMOUNT: "AMOUNT",
};
export const DISCOUNT_CODE_STATUSES = {
    VALID: "VALID",
    INVALID: "INVALID",
};

export const PRODUCT_STATUSES = {
    ON_SALE: "sale",
    CAMPAIGN: "kampanj",
};

type ShippingSpec = {
    id: string;
    name: string;
    price: number;
    externalId: number;
    description: string;
    default?: boolean;
    filter?: (customerType: CustomerObject) => boolean;
};

export const SHIPPINGS: Record<string, ShippingSpec> = {
    regular: {
        id: "regular",
        name: "PostNord Postombud",
        price: 149,
        externalId: 0,
        description: "Hämta paketet hos närmaste PostNord postombud. Avisering via SMS, e-mail eller avi.",
        default: true,
    },
    home: {
        id: "home",
        name: "PostNord Hemleverans",
        price: 295,
        externalId: 1,
        description:
            "Innan leverans så får du ett meddelande av Postnord där du kan välja hur och när ditt paket skall levereras.",
        filter: (customerType: CustomerObject) => {
            return customerType.id === CUSTOMER_TYPE_IDS.PRIVATE;
        },
    },
    company: {
        id: "company",
        name: "PostNord Företagspaket",
        price: 295,
        externalId: 2,
        description:
            "Paketet körs ut till arbetsplatsen under dagtid utan avisering. Det måste alltid finnas någon på plats som kan ta emot försändelsen.",
        filter: (customerType: CustomerObject) => {
            return customerType.id === CUSTOMER_TYPE_IDS.COMPANY;
        },
    },
    pickup: {
        id: "pickup",
        name: "Hämta i Dalsjöfors",
        price: 0,
        externalId: 3,
        description:
            "Hämta beställningen i vår butik i Dalsjöfors utanför Borås. Du får ett SMS så fort beställningen är redo att hämtas.",
    },
    letter: {
        id: "letter",
        name: "Brev",
        price: 0,
        externalId: 4,
        description: "Skickas som vanligt brev direkt till din brevlåda.",
    },
    dhl_servicepoint: {
        id: "dhl_servicepoint",
        name: "DHL Servicepoint",
        price: 149,
        externalId: 5,
        description: "Hämta paketet hos närmaste DHL Servicepoint. Avisering via SMS eller e-mail.",
    },
    dhl_home: {
        id: "dhl_home",
        name: "DHL Hemleverans",
        price: 395,
        externalId: 6,
        description:
            "Innan leverans så får du ett meddelande av DHL där du kan välja hur och när ditt paket skall levereras.",
        filter: (customerType: CustomerObject) => {
            return customerType.id === CUSTOMER_TYPE_IDS.PRIVATE;
        },
    },
    dhl_ftg: {
        id: "dhl_ftg",
        name: "DHL Företagspaket",
        price: 295,
        externalId: 7,
        description:
            "Paketet körs ut till arbetsplatsen under dagtid utan avisering. Det måste alltid finnas någon på plats som kan ta emot försändelsen.",
        filter: (customerType: CustomerObject) => {
            return customerType.id === CUSTOMER_TYPE_IDS.COMPANY;
        },
    },
};

const ACTIVE_SHIPPING_IDS = ["pickup", "letter", "dhl_servicepoint", "dhl_home", "dhl_ftg"];
export const ACTIVE_SHIPPINGS = Object.entries(SHIPPINGS).reduce((tot, [key, shipping]) => {
    if (ACTIVE_SHIPPING_IDS.includes(shipping.id)) {
        tot[key] = shipping;
    }
    return tot;
}, {} as Partial<typeof SHIPPINGS>);

export const PACKAGE_SIZE = {
    TINY: "tiny", // letter, for samples
    NORMAL: "normal",
    LARGE: "large",
};

export type CustomerType = "private" | "company";
export const CUSTOMER_TYPE_IDS: Record<Uppercase<CustomerType>, CustomerType> = {
    PRIVATE: "private",
    COMPANY: "company",
};

export type CustomerObject = { id: CustomerType; name: string };
export type CustomerTypes = Record<CustomerType, CustomerObject>;
export const CUSTOMER_TYPES: CustomerTypes = {
    ["private"]: {
        id: CUSTOMER_TYPE_IDS.PRIVATE,
        name: "Privatperson",
    },
    ["company"]: {
        id: CUSTOMER_TYPE_IDS.COMPANY,
        name: "Företag",
    },
};

export const PAYMENT_TYPES = {
    prepayed: {
        id: "prepayed",
        name: "Förskottsbetalning (bankgiro)",
    },
    klarna: {
        id: "klarna",
        name: "Klarna (faktura eller delbetalning)",
    },
};

export const ORDER_STATUS = {
    WAITING: 0,
    CONFIRMED: 1,
    DENIED: -3,
};

export const captureTypes = {
    FULL: "full",
    PART: "part",
};

export const klarnaStatuses = {
    AUTHORIZED: "AUTHORIZED",
    CAPTURED: "CAPTURED",
    PART_CAPTURED: "PART_CAPTURED",
    EXPIRED: "EXPIRED",
    NOT_FOUND: "NOT_FOUND",
};
